
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 248 196","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M201.5 193.885c25.672 0 46.5-21.711 46.5-48.471V48.471C248 21.711 227.172 0 201.5 0h-40.688C157.422 0 155 3.03 155 6.059v20.196c0 3.535 2.422 6.06 5.812 6.06H201.5c8.234 0 15.5 7.573 15.5 16.156v96.943c0 9.088-7.266 16.157-15.5 16.157h-40.688c-3.39 0-5.812 3.029-5.812 6.059v20.196c0 3.534 2.422 6.059 5.812 6.059H201.5zM178.734 92.398L97.359 7.574C90.094 0 77.5 5.554 77.5 16.157v48.471H11.625C4.844 64.628 0 70.182 0 76.746v48.471c0 7.069 4.844 12.118 11.625 12.118H77.5v48.471c0 11.108 12.594 16.158 19.86 8.584l81.374-84.825c4.36-4.544 4.36-12.118 0-17.167z","fill":"currentColor"}})])
          )
        }
      }
    